import {Writable, writable} from 'svelte/store';
import {SimpleErrors} from "../../types";

export let formErrors:  Writable<SimpleErrors> = writable(null)
